import { useCallback, useState } from 'react';
import { Box, HStack, Image, Skeleton } from '@chakra-ui/react';

interface ImageCarouselProps {
	images: string[];
}

export const ImageCarousel: React.FunctionComponent<ImageCarouselProps> = ({ images }) => {
	const [selectedIndex, setSelectedIndex] = useState<number>(0);
	const [loading, setLoading] = useState<boolean>(true);

	const loadingOn = useCallback(() => setLoading(true), []);
	const loadingOff = useCallback(() => setLoading(false), []);
	const onClick = useCallback(
		// curried callback with index as initial argument
		(index) => () => {
			setSelectedIndex(index);
			setLoading(true);
		},
		[]
	);

	if (!images || images.length === 0) {
		return <></>;
	}

	return (
		<Box as='section' p={2} pb={0} bg='white' position='relative'>
			{loading && <Skeleton height='300px' width='full' borderRadius='lg' />}
			<Image
				src={images[selectedIndex]}
				width='full'
				h='300px'
				maxH='300px'
				borderRadius='lg'
				objectFit='cover'
				onLoadStart={loadingOn}
				onLoad={loadingOff}
				onError={loadingOff}
				display={loading ? 'none' : 'block'}
			/>
			<HStack alignItems='center' justifyContent='center' gap={2} position='absolute' width='full' bottom='20px'>
				{images.map((url, index) => (
					<Image
						key={index}
						src={url}
						borderRadius='md'
						width='60px'
						height='60px'
						borderColor={`${selectedIndex === index ? 'white' : 'black'} !important`}
						border={`${selectedIndex === index ? 3 : 1}px solid`}
						cursor='pointer'
						onClick={onClick(index)}
					/>
				))}
			</HStack>
		</Box>
	);
};
